import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { AddPaymentModal } from '../components/AddPaymentModal';
import { RecordPageBackdrop } from '../components/RecordPageBackdrop';
import { scenarios } from '../data/scenarios';
export function Demo({
  scenarioId
}: {
  scenarioId: string;
}) {
  const scenario = scenarios.find(item => item.id === scenarioId) ?? scenarios[0];
  const [open, setOpen] = useState(true);
  return <div className="relative min-h-[calc(100vh-45px)] w-full" data-id="element-235" data-mp="39pfin3l94wl1">
      <RecordPageBackdrop payPeriod={scenario.payPeriod} data-id="element-236" data-mp="3elw7y146tgzp" />

      {open ? <div className="relative flex min-h-[calc(100vh-45px)] items-start justify-center bg-ink-900/45 px-4 py-8 backdrop-blur-[1px]" data-id="element-237" data-mp="3ioj0y5clh7yh">
          <AddPaymentModal key={scenario.id} payPeriod={scenario.payPeriod} initialPaymentType={scenario.paymentType} initialValues={scenario.values} initialStep={scenario.step ?? 'form'} forceFailure={scenario.forceFailure} unavailable={scenario.unavailable ?? null} onClose={() => setOpen(false)} data-id="element-238" data-mp="3no5decklmk68" />
        </div> : <div className="relative flex min-h-[calc(100vh-45px)] items-center justify-center px-4" data-id="element-239" data-mp="28d9jwxyzcewz">
          <button type="button" onClick={() => setOpen(true)} className="inline-flex items-center gap-2 rounded-md bg-brand-600 px-5 py-2.5 text-sm font-semibold text-white shadow-card transition hover:bg-brand-700 focus:outline-none focus:ring-4 focus:ring-brand-200" data-id="element-240" data-mp="23icee10wsnou">
            <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-241" data-mp="1kprrr1bszeth" />
            Add Payment
          </button>
        </div>}
    </div>;
}